
import { defineComponent, reactive, toRefs, computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import treeSelect from "../modules/treeSelect.vue";
import { ElMessage } from "element-plus";
import { addOrModifyApiGroup } from "@/service/api";

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      default: {},
    },
    groupTreeData: {
      type: Object,
      default: [],
    },
  },
  components: {
    treeSelect,
  },
  emits: ["handleSearch", "close-modal"],
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const state = reactive({
      formItem: {
        id: "", //接口参数id
        parentId: "",
        title: "",
        description: "",
        sort: 1,
        userId: computed(() => store.state.manageUser.userId),
        userRealname: computed(() => store.state.manageUser.name),
      },
      clickModalClose: false,
      ruleValidate: {
        title: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入序号",
            type: "number",
            trigger: "blur",
          },
        ],
      },
      //配置树形数据的label和value
      selectProp: {
        value: "id",
        label: "title",
      },
    });
    const treeData = ref<any>(null); //修改时去除自身的树形数据
    const ruleForm = ref<any>(null);
    const loading = ref(true);
    const treeSelect = ref<any>(null); //树形选择器ref
    //选择分组
    function handleSelect(data: any) {
      state.formItem.parentId = data.id;
    }
    //点击确定
    function addSubmit() {
      ruleForm.value.validate(async (valid: boolean) => {
        if (valid) {
          const para = Object.assign({}, state.formItem);
          if (para.parentId == null) {
            para.parentId = "0";
          }
          const result = await addOrModifyApiGroup(para);
          if (result && parseInt(result.code) === 1) {
            ElMessage({ message: props.title + "成功", type: "success" });
            cancel();
            context.emit("handleSearch");
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          return false;
        }
      });
    }
    //取消审核
    function cancel() {
      ruleForm.value.resetFields();
      state.formItem.id = "";
      state.formItem.title = "";
      state.formItem.description = "";
      state.formItem.parentId = "";
      state.formItem.sort = 1;
      treeData.value = [];
      treeSelect.value.clearValue();
      context.emit("close-modal");
    }
    function filter(data: any, id: string) {
      let newData = data.filter((item: any) => {
        return item.id !== id;
      });
      newData.forEach((item: any) => {
        if (item.children && item.children.length > 0) {
          item.children = filter(item.children, id);
        }
      });
      return newData;
    }
    watch(
      () => props.dialogVisible,
      (newVal) => {
        if (newVal) {
          loading.value = true;
          if (props.formData.id != "" && props.formData.id != undefined) {
            state.formItem.id = props.formData.id;
            state.formItem.title = props.formData.title;
            state.formItem.description = props.formData.description;
            state.formItem.sort = props.formData.sort;
            if (props.formData.parentId && props.formData.parentId != "0") {
              state.formItem.parentId = props.formData.parentId;
            }
            //修改时，父级分组过滤掉自己
            treeData.value = filter(props.groupTreeData, props.formData.id);
            context.emit("handleSearch");
          } else {
            treeData.value = props.groupTreeData;
          }
          loading.value = false;
        }
      }
    );
    return {
      ...toRefs(state),
      ruleForm,
      cancel,
      addSubmit,
      loading,
      handleSelect,
      treeData,
      treeSelect,
    };
  },
});
